import { Component, Input, OnInit } from '@angular/core';
import { OverheatingAlarm } from '../../../../alarm/alarm-definitions/overheating.alarm';
import { TrainDepartureAlarm } from '../../../../alarm/alarm-definitions/train-departure.alarm';
import { TrainDependencyAlarm } from '../../../../alarm/alarm-definitions/train-dependency.alarm';
import { TrainStoppedAlarm } from '../../../../alarm/alarm-definitions/train-stopped.alarm';
import { VoltageAlarm } from '../../../../alarm/alarm-definitions/voltage.alarm';
import { WheelAlertAlarm } from '../../../../alarm/alarm-definitions/wheel-alert.alarm';
import { AlarmMessage } from '../../../../alarm/alarm-message';

@Component({
  selector: 'qm-train-list-alarm',
  templateUrl: './train-list-alarm.component.html',
  styleUrls: ['./train-list-alarm.component.scss']
})
export class TrainListAlarmComponent implements OnInit {

  @Input() public alarm: AlarmMessage<TrainDepartureAlarm | TrainStoppedAlarm | TrainDependencyAlarm | WheelAlertAlarm | OverheatingAlarm | VoltageAlarm>;

  constructor() { }

  ngOnInit(): void {
  }

}
